<fieldset *ngIf="show">
    <legend class="ib-gift-cards__title padding-top-gift-cards-theme-component">{{'GIFT_CARD_CONFIGURATION_SELECT_THEME'|translate}}</legend>
    <div class="ib-layout__line-spacing ib-layout__line-spacing--large u-mb-none-mobile">
        <div class="row card-margin-bottom" equalHeight>
            <div *ngFor="let item of modelItemFirstRow; index as i">
                <ib-gift-cards-theme-item-component 
                [model]="item"
                (themeChange)="onThemeChange($event)">
                ></ib-gift-cards-theme-item-component>
            </div>
        </div>
        <div class="ib-layout__line-spacing ib-layout__line-spacing--large u-mb-mobile">
            <div class="row" equalHeight>
                <div *ngFor="let item of modelItemSecondRow; index as i">
                <ib-gift-cards-theme-item-component 
                [model]="item"
                (themeChange)="onThemeChange($event)">
                ></ib-gift-cards-theme-item-component>
            </div>
                
            </div>
        </div>
    </div>
</fieldset>
